module.exports = __webpack_public_path__ + "img/bm_icon_2.3a550398.png";